// A geography-sensitive response that arrived after the browsing location
// changed. It is not a failure to show: a newer request owns the screen.
export const isStaleLocationError = (error) => error?.code === 'STALE_DELIVERY_GEOGRAPHY';
